import { Box } from '@mui/material';
import {
	getRegistrationData,
	saveTokenFromRegistration,
	setRegistrationData,
	updateInvestorSteps,
} from '../../../../../../services/authService';
import { ButtonWrapper } from '../../../../../../shared/components/formUtilities/useButton';
import { FormikProvider, getIn, useFormik } from 'formik';
import { FormHelper } from '../../../../../../helpers/formHelper';
import SelectWrapper from '../../../../../../shared/components/formUtilities/useSelect';
import { useEffect, useState } from 'react';
import { InputWrapper } from '../../../../../../shared/components/formUtilities/useInput';
import { DatePickerWrapper } from '../../../../../../shared/components/formUtilities/useDatePicker';
import { useTranslation } from 'react-i18next';
import { ArrowIcons } from '../../../../../../shared/components/common/arrowIcons';
import { InvestorType } from '../../../../../../constants/investorType';
import { InvestorRegService } from '../../../investorRegService';
import { investorPersonalInfoRegSchema } from '../../../../../../shared/validations/schema';
import { useSelector } from 'react-redux';
import { SubStepper } from '../../../../components/subStepper';
import { InvestorService } from '../../../../../investor/investorService';
import { IS_SA } from '../../../../../../config/appConfig';
import { LanguageService } from '../../../../../../services/languageService';
import { SwitchToSaudiDialog } from '../../../../components/switchToKSADialog';
import { LocalStorageKey } from '../../../../../../constants/localStorageKeys';
import { setURLParam } from '../../../../../../helpers/setParamUrlHelper';
import { RegistrationURLSteps } from '../../../../../../constants/registrationURLStep';

export const PersonalInfoGlobal = ({
	onSubmit = (nationalityId, countryOfResidenceId) => { },
	onBack = () => { },
	investorType = {},
}) => {
	const investorRegService = new InvestorRegService();
	const investorService = new InvestorService();
	const languageService = new LanguageService();
	const { t } = useTranslation();

	const { investorCollections } = useSelector(
		(state) => state.investorCollectionReducer
	);
	const counties = investorCollections?.countryCollection;
	const hearAboutUsList = investorCollections?.hearUsItemCollection;

	const [loading, setLoading] = useState(false);
	const [personalInfo, setPersonalInfo] = useState(null);
	const [isPhoneKSA, setIsPhoneKSA] = useState(false);
	const [showKSAPopup, setShowKSAPopup] = useState(false);
	const [isCorporate, setIsCorporate] = useState(false);

	const form = useFormik({
		initialValues: {
			firstName: '',
			lastName: '',
			howDidHearAboutUs: FormHelper.buildOtherFormGroup(),
			birthDate: '',
			placeOfBirth: '',
			nationalityCountryId: '',
			placeOfBirthCountry: "",
			placeOfBirthId: '',
			address: FormHelper.buildAddressFormGroup(),
		},
		validationSchema: investorPersonalInfoRegSchema,
		onSubmit: (values) => {
			if ((checkPlaceOfBirth() && !form.values?.placeOfBirthId) || (!checkPlaceOfBirth() && !form.values?.placeOfBirth)) {
				return;
			}
			onCloseKSAPopup();
			onSumbitPersonalInfo(values);
		},
		...FormHelper.formikProps(),
	});

	const nationalityControl = getIn(form?.values, 'nationalityCountryId');
	const countryControl = getIn(form?.values, 'address.countryId');

	useEffect(() => {
		setURLParam('currentStep', RegistrationURLSteps.personalInfo);
	}, []);

	useEffect(() => {
		setIsCorporate(investorType?.name === InvestorType.Corporate);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [investorType]);

	useEffect(() => {
		if (!IS_SA) {
			getInvestorDetails();
		}
		getInvestorPersonalDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const residenceCountry = getIn(form.values, "address.countryId");
	const nationalityCountryId = getIn(form.values, "nationalityCountryId");

	useEffect(() => {
		let name = counties?.filter((resp) => resp?.id === countryControl)[0]?.name;
		let data = {
			...getRegistrationData(),
			addressCountry: name,
		};
		setRegistrationData(data);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countryControl]);

	useEffect(() => {
		if (
			!IS_SA && (!localStorage.getItem(LocalStorageKey.isKSApopup) || localStorage.getItem(LocalStorageKey.isKSApopup) === "0") &&
			((languageService.isArabic() && (residenceCountry === 1 || nationalityCountryId === 1)) ||
				(!languageService.isArabic() && (residenceCountry === 1 || isPhoneKSA || nationalityCountryId === 1)))
		) {
			setShowKSAPopup(true);
		} else {
			setShowKSAPopup(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [residenceCountry, isPhoneKSA, nationalityCountryId]);

	useEffect(() => {
		if (!nationalityControl && !personalInfo) return;
		const selectedNationality = counties?.find(
			(country) => country?.id === nationalityControl
		);
		if (nationalityControl && !selectedNationality) return;

		const data = {
			...getRegistrationData(),
			nationality: selectedNationality?.name
		};
		setRegistrationData(data);
	}, [nationalityControl, counties, personalInfo]);

	const getInvestorDetails = () => {
		investorService.getInvestor().then(resp => {
			let investor = resp.data;
			if (investor && investor?.contactNumber && investor?.contactNumber?.code) {
				let code = investor?.contactNumber?.code;
				setIsPhoneKSA(code === "966" || code === "+966");
			} else {
				setIsPhoneKSA(false);
			}
		}).catch(err => { });
	};

	const getInvestorPersonalDetails = () => {
		investorRegService
			.getInvestorPersonalInformation()
			.then((resp) => {
				let data = resp.data;
				let personalInfo = {
					...data,
					firstName: data?.firstName || '',
					lastName: data?.lastName || '',
					placeOfBirthId: data?.placeOfBirthCountry?.id || null,
					nationalityCountryId: data?.nationalityCountry?.id,
					howDidHearAboutUs: FormHelper.getComplexOther(data.howDidHearAboutUs),
					birthDate:
						data?.birthDate === '0001-01-01T00:00:00' ? '' : data?.birthDate,
					address: {
						addressLine: data?.address?.addressLine,
						postalCode: data?.address?.postalCode,
						countryId: data?.address?.country?.id,
					},
				};
				setTimeout(() => {
					setPersonalInfo(personalInfo);
					form.setValues(personalInfo);
				});
			})
			.catch((err) => { });
	};

	const onSumbitPersonalInfo = (values) => {
		setLoading(true);
		investorRegService
			.submitPersonalInformation(values)
			.then((response) => {
				let resp = response.data;
				let registrationModel = resp?.registrationModel;
				saveTokenFromRegistration(resp?.loginModel?.token);
				let regData = {
					...getRegistrationData(),
					step: registrationModel.step,
					investorType:
						registrationModel?.personalInformation?.investorType?.name,
					requestedStep: 2,
				};
				setRegistrationData(regData);
				updateInvestorSteps(registrationModel.step);
				setLoading(false);
				onSubmit(nationalityCountryId, residenceCountry);
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	const checkPlaceOfBirth = () => {
		if (personalInfo?.placeOfBirthId) {
			return true;
		}
		if (personalInfo?.placeOfBirth && !personalInfo?.placeOfBirthId) {
			return false;
		}
		return true;
	};

	const onCloseKSAPopup = () => {
		localStorage.setItem(LocalStorageKey.isKSApopup, "1");
		setShowKSAPopup(false);
	};

	return (
		<FormikProvider value={form}>
			<Box>
				<SubStepper
					stepName={
						isCorporate ? 'personalInformation' : 'personalInformation1'
					}
					currentStep={1}
					totalSteps={2}
				/>
				<Box className="grid grid-cols-1 md:grid-cols-2 gap-4">
					<InputWrapper
						dataTestID='firstName'
						errorStateTestID="firstNameError"
						name={'firstName'}
						key={'firstName'}
						label={
							isCorporate ? 'firstNameSignatory' : 'firstName'
						}></InputWrapper>
					<InputWrapper
						dataTestID='lastName'
						errorStateTestID="lastNameError"
						name={'lastName'}
						key={'lastName'}
						label={
							isCorporate ? 'lastNameSignatory' : 'lastName'
						}></InputWrapper>
					<DatePickerWrapper
						dataTestID='birthDate'
						errorStateTestID="birthDateError"
						defaultMaxDate={true}
						name={'birthDate'}
						key={'birthDate'}
						label={isCorporate ? `${t('dateOfBirth')} ${t('ofSignatory')}` : 'dateOfBirth'}></DatePickerWrapper>
					{checkPlaceOfBirth() ? <SelectWrapper
						externalErrorMessage={!form.values?.placeOfBirthId ? 'required' : ''}
						dataTestID='placeOfBirthId'
						errorStateTestID="placeOfBirthId"
						name={'placeOfBirthId'}
						key={'placeOfBirthId'}
						items={counties}
						label={isCorporate ? `${t('placeOfBirth')} ${t('ofSignatory')}` : 'placeOfBirth'}
					/> : <InputWrapper
						externalErrorMessage={!form.values?.placeOfBirth ? 'required' : ''}
						dataTestID='placeOfBirth'
						errorStateTestID="placeOfBirthError"
						name={'placeOfBirth'}
						key={'placeOfBirth'}
						label={isCorporate ? `${t('placeOfBirth')} ${t('ofSignatory')}` : 'placeOfBirth'}
					></InputWrapper>}

					<SelectWrapper
						dataTestID='nationalityCountryId'
						errorStateTestID="nationalityCountryIdError"
						name={'nationalityCountryId'}
						key={'nationalityCountryId'}
						items={counties}
						label={isCorporate ? `${t('nationality')} ${t('ofSignatory')}` : 'nationality'}
					/>
					<InputWrapper
						dataTestID='addressLine'
						errorStateTestID="addressLineError"
						name={'address.addressLine'}
						key={'address.addressLine'}
						label={isCorporate ? `${t('address')} ${t('ofSignatory')}` : 'address'}
					></InputWrapper>
					<SelectWrapper
						dataTestID='countryId'
						errorStateTestID="countryIdError"
						name={'address.countryId'}
						key={'address.countryId'}
						items={counties}
						label={isCorporate ? `${t('countryOfResidence')} ${t('ofSignatory')}` : 'countryOfResidence'}
					/>
					<SelectWrapper
						valueSpecifiedNames={['Other', 'Influencer']}
						name={'howDidHearAboutUs.valueId'}
						key={'howDidHearAboutUs.valueId'}
						controlOtherValueName={'howDidHearAboutUs.valueSpecified'}
						items={hearAboutUsList}
						label={'howHearAboutUs'}
					/>
				</Box>
				<Box className="mt-4 flex justify-center md:justify-between">
					<ButtonWrapper
						dataTestID="backBtn"
						classList="!secondary-btn md:!mx-0 !mx-2"
						disabled={loading}
						largeBtn
						icon={<ArrowIcons isInvert></ArrowIcons>}
						label={t('back')}
						onClick={() => {
							onBack && onBack();
						}}
					/>
					<ButtonWrapper
						dataTestID="nextBtn"
						loading={loading}
						largeBtn
						endIcon={<ArrowIcons></ArrowIcons>}
						label={t('next')}
						onClick={() => {
							FormHelper.validateForm(form);
						}}
					/>
				</Box>
				<SwitchToSaudiDialog isShow={showKSAPopup} onClose={() => {
					onCloseKSAPopup();
				}} />
			</Box>
		</FormikProvider>
	);
};
